<template>
    <div class="content">

        <!-- <el-tabs v-model="activeName" type="border-card" style="margin-top: 10px" > -->
            <!-- <el-tab-pane label="报告小程序" name="first"> -->

                <div class="searchContent">
                    <!--<el-button class="btn sa_qr_btn"  @click="seeSACode" > 查看sa绑定二维码</el-button>-->
                    <!--<el-button class="btn other_qr_btn" @click="bindOtherQrCode = true" > 其他人员二维码</el-button>-->
                    <div class="p_select">
                        <a  class="btn_dafule hover_btn_2" @click="seeSACode" style="background: #2B54FC;">
                            <img src="../../assets/image/sa.png" alt="">
                        </a>
                        <div class="hover_img_2"><img src="../../assets/image/btn_2_hover.png" alt=""></div>
                    </div>
                    <div class="p_select">
                        <a  class="btn_dafule hover_btn_1" @click="bindOtherQrCode = true">
                            <img src="../../assets/image/other.png" alt="">
                        </a>
                        <div class="hover_img_1"><img src="../../assets/image/btn_1_hover.png" alt=""></div>
                    </div>
                </div>

                <div class="list_box">
                    <el-tabs v-model="activeNameInside">
                        <el-tab-pane label="已绑人员" name="first">
                            <div class="list_content">
                                <el-table :data="SAWxAppList" :height="winHeight" :cell-style="setRowStyle"  :header-cell-style="getHeaderStyle" >
                                    <el-table-column prop="saId" label="用户ID"></el-table-column>
                                    <el-table-column prop="saName" label="服务顾问"></el-table-column>
                                    <el-table-column prop="phoneLabel" label="联系电话"></el-table-column>
                                    <el-table-column prop="WxOpenIDLabel" label="微信ID"></el-table-column>
                                    <el-table-column fixed="right" label="操作">
                                        <template slot-scope="scope">
                                            <el-button @click="unboundSAWx(scope.row)" type="warning" size="small" class="update_btn">解绑</el-button>
                                            <el-button @click="testSendToWx(scope.row)" type="success" size="small" class="update_btn" >测试推送</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <div class="pagination">
                                <el-pagination
                                        @size-change="handleSizeChangeBind"
                                        @current-change="handleCurrentChangeBind"
                                        background
                                        :current-page="pageNoBind"
                                        :page-sizes="[10, 20, 30, 40]"
                                        :page-size="pageSizeBind"
                                        layout="total, sizes, prev, pager, next, jumper"
                                        :total="totalBind"
                                ></el-pagination>
                            </div>

                        </el-tab-pane>
                        <el-tab-pane label="未绑人员" name="second">
                            <div class="list_content">
                                <el-table :data="SAWxAppListNo" :height="winHeight" :cell-style="setRowStyle"  :header-cell-style="getHeaderStyle"  >
                                    <el-table-column prop="saId" label="用户ID"></el-table-column>
                                    <el-table-column prop="saName" label="服务顾问"></el-table-column>
                                    <el-table-column prop="phoneLabel" label="联系电话"></el-table-column>
                                </el-table>
                            </div>
                            <div class="pagination">
                                <el-pagination
                                        @size-change="handleSizeChangeBindNo"
                                        @current-change="handleCurrentChangeBindNo"
                                        background
                                        :current-page="pageNoBindNo"
                                        :page-sizes="[10, 20, 30, 40]"
                                        :page-size="pageSizeBindNo"
                                        layout="total, sizes, prev, pager, next, jumper"
                                        :total="totalBindNo"
                                ></el-pagination>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>



            <!-- </el-tab-pane> -->
        <!-- </el-tabs> -->



        <el-dialog :visible.sync="bindSaQrCode" title="SA绑定小程序用 二维码" width="360px" >
            <div>{{orgName}}</div>
            <br />
            <vue-qr id="qrcodeRe" class="qrcode" :text="bindSaQrCodeUrl" :size="200"></vue-qr>
            <!--<span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="bindSaQrCode = false">关闭</el-button>
            </span>-->
        </el-dialog>
        <el-dialog :visible.sync="bindOtherQrCode" title="其他人员绑定二维码" width="360px" >
            <div>{{orgName}}</div>
            <br />
            <vue-qr id="otherQrcodeRe" class="qrcode" :text="bindOtherQrCodeUrl" :size="200"></vue-qr>
        </el-dialog>


    </div>
</template>

<script>
  import net from "../../assets/js/public";
  import vueQr from "vue-qr";
  export default {
    name: "trussManage",
    components: {
      vueQr
    },
    data(){
      return {
        orgId:'',
        orgName:'',
        activeName: 'first',
        activeNameInside: 'first',
        winHeight:'200',

        SAWxAppList:[],
        pageNoBind:1,
        pageSizeBind:10,
        totalBind:0,

        SAWxAppListNo:[],
        pageNoBindNo:1,
        pageSizeBindNo:10,
        totalBindNo:0,

        bindSaQrCode: false,
        bindSaQrCodeUrl:'',
        bindOtherQrCode:false,
        bindOtherQrCodeUrl:'https://autoepacs.com/qr/report?bindUser=true'
      }
    },
    created() {
      var signInfo = JSON.parse(sessionStorage.getItem("signInfo"));
      this.orgId = signInfo.orgId ;
      this.orgName = signInfo.orgName
      this.loadDossierWxAppBindUser()
      this.loadDossierWxAppBindUserNo()
    },
    methods: {
      getHeaderStyle() {
        return "background-color:#F3F7FB; color: #364556; text-align: left;font-size: 14px;height: 48px;font-weight: 500;font-family: 'PingFang SC';";
      },
      setRowStyle(row, column, rowIndex, columnIndex) {
        if(row.columnIndex == 0){
          return 'color: #0D0E12;font-weight: 500;font-size: 14px;'
        }else{
          return 'color: #0D0E12;font-weight: 400;'
        }
      },

      // 已绑定列表
      loadDossierWxAppBindUser(){
        const params = {
          orgId: this.orgId,
          pageNo: this.pageNoBind,
          pageSize: this.pageSizeBind,
          status:1
        }
        net.request('admin/manage/staff/loadBindStatusSaList','post',params).then(res => {
          if (res.code === 0) {
            let data = res.data.rows
            data.forEach(item => {
              if(item.WxOpenID){
                item.WxOpenIDLabel = item.WxOpenID.substr(0, 3) + '****' + item.WxOpenID.substr(item.WxOpenID.length - 4)
              }else {
                item.WxOpenIDLabel = "-"
              }
              if(item.phone.length >= 11){
                item.phoneLabel = item.phone.substr(0, 3) + '****' + item.phone.substr(item.phone.length - 4)
              }else {
                item.phoneLabel = item.phone
              }
            })
            this.totalBind = res.data.total
            this.SAWxAppList = data
            const windiwHight = document.documentElement.clientHeight || document.body.clientHeight // 可视屏幕高度
            this.winHeight = windiwHight - 356
          } else {
            net.message(this, res.msg, "warning")
          }
        })
      },
      handleSizeChangeBind(val){
        this.pageSizeBind = val;
        this.loadDossierWxAppBindUser()
      },
      handleCurrentChangeBind(val){
        this.pageNoBind = val
        this.loadDossierWxAppBindUser()
      },

      // 未绑定
      loadDossierWxAppBindUserNo(){
        const params = {
          orgId: this.orgId,
          pageNo: this.pageNoBindNo,
          pageSize: this.pageSizeBindNo,
          status:0
        }
        net.request('admin/manage/staff/loadBindStatusSaList','post',params).then(res => {
          if (res.code === 0) {
            let data = res.data.rows
            this.totalBindNo = res.data.total
            data.forEach(item => {
              if(item.phone.length >= 11){
                item.phoneLabel = item.phone.substr(0, 3) + '****' + item.phone.substr(item.phone.length - 4)
              }else {
                item.phoneLabel = item.phone
              }
            })
            this.SAWxAppListNo = data
            const windiwHight = document.documentElement.clientHeight || document.body.clientHeight // 可视屏幕高度
            this.winHeight = windiwHight - 356
          } else {
            net.message(this, res.msg, "warning")
          }
        })
      },
      handleSizeChangeBindNo(val){
        this.pageSizeBindNo = val;
        this.loadDossierWxAppBindUserNo()
      },
      handleCurrentChangeBindNo(val){
        this.pageNoBindNo = val
        this.loadDossierWxAppBindUserNo()
      },



      // 查看sa绑定二维码
      seeSACode(){
        net.request('admin/manage/staff/getBindSaQrCode', 'post',).then(res => {
          if(res.code === 0){
            this.bindSaQrCode = true
            this.bindSaQrCodeUrl = res.data
          }
        })
      },
      // 解绑SA
      unboundSAWx(row){
        this.$confirm(`确定解绑${row.saName}？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const params = {
            wxOpenId: row.WxOpenID
          }
          net.request('admin/manage/staff/unbindDossierWxAppBindUser','post',params).then(res => {
            if (res.code === 0) {
              net.message(this, res.msg, "success")
              this.loadDossierWxAppBindUser()
            } else {
              net.message(this, res.msg, "warning")
            }
          })
        })


      },

      //测试推送
      testSendToWx(row){
        net.request('admin/manage/staff/testSendToWxAppBindUser', 'post', {wxOpenId:row.WxOpenID}).then(res => {
          if(res.retcode === 1){
            net.message(this, res.retmsg, "success")
          }else {
            net.message(this, res.retmsg, "warning")
          }
        })

      },
    }
  };
</script>

<style lang='less' scoped>
    /deep/ .el-table th.el-table__cell {
        background: #F3F7FB !important;
        color: #364556;
    }
.content {
  padding-left: 24px;
  margin-top: 24px;
}
    .title {
        width: 100%;
        height: 50px;
        line-height: 50px;
        background: #eaeefb;
        color: red;
        font-size: 20px;
        font-weight: 700;
    }
    .searchContent {
      background: #fff;
      padding: 0 24px;
      border-radius: 8px;
      display: flex;
      flex-direction: row;
        .p_select {
            position: relative;
            display: flex;
            padding: 24px 24px 24px 0;
            font-size: 12px;
            float: left;
            .search_label{
                font-family: 'PingFang SC';
                font-style: normal;
                margin-right: 12px;
                font-weight: 500;
                font-size: 14px;
                line-height: 40px;
                color: #787E86;
                white-space:nowrap
            }

            .el-input , .el-select{
                width: 160px;
            }

            .btn_dafule {
                width: 72px;
                height: 38px;
                display: block;
                background: #29D3BF;
                box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
                border-radius: 4px;
                img {
                    width: 24px;
                    height: 24px;
                    margin-top: 7px;
                }
            }
            .hover_img_2 {
                position: absolute;
                left: 0px;
                top: -22px;
                opacity: 0;
            }
            .hover_img_1 {
                position: absolute;
                left: 0px;
                top: -22px;
                opacity: 0;
            }
            .hover_btn_2:hover ~.hover_img_2{
                opacity: 1;
            }
            .hover_btn_1:hover ~.hover_img_1{
                opacity: 1;
            }
        }
      .btn {
        width: 165px;
        height: 36px;
        box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
        border-radius: 4px;
        font-size: 14px;
        color: #FFFFFF;
          font-family: 'PingFang SC';
          font-style: normal;
          font-weight: 500;
      }
      .sa_qr_btn {
          background: #2B54FC;
      }
      .other_qr_btn {
        background: #29D3BF;
      }
      .el-input--suffix {
          width: 200px;
          margin-right: 20px;
      }
    }
    .list_box {
        border-radius: 8px;
        background: #fff;
        margin-top: 24px;
        padding: 12px 24px;
    }
    .list_content {
        margin-top: 20px;
        padding-right: 24px;
    }
    .pagination {
        position: relative;
        margin-top: 10px;
        height: 40px;
        .el-pagination {
            position: absolute;
            right: 24px;
            .el-pager li:not(.disabled) {
                .active {
                    background: #009688 !important;
                }
            }
        }
    }

    .el-pagination.is-background .el-pager li:not(.disabled).active {
        background: #009688;
    }
    .select_box {
        text-align: left;
        margin-bottom: 10px;
        .select_title {
            display: inline-block;
            width: 100px;
            text-align: right;
            margin-right: 20px;
        }
    }
    .img_box {
        display: flex;
        .del_box {
            line-height: 150px;
            margin-left: 50px;
        }
    }
    .update_btn {
      height: 28px;
      background: rgba(148, 170, 204, 0.08);
      border: 1px solid #E3E7ED;
      border-radius: 14px;
      font-size: 12px;
      color: #364556;
      text-align: center;
    }
</style>
